export default "__VITE_ASSET__9aacf7c2__"